/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import classNames from "classnames";
import "./StatsCard.scss";
export class StatsCard extends Component {
  render() {
    const isFiltered = !!this.props.isFiltered;
    return (
      <div className="card card-stats card-stats-responsive">
        <div className="content">
          <div className="row">
            <div className="col-xs-5">
              <div className="icon-big text-center icon-warning">{this.props.bigIcon}</div>
            </div>
            <div className="col-xs-7">
              <div className={classNames({ numbers: true, filtered: isFiltered })}>
                <p>{this.props.statsText}</p>
                {this.props.statsValue}
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <hr />
          <div className={classNames({ stats: true, filtered: isFiltered })}>
            {this.props.statsIcon} {this.props.statsIconText}
          </div>
        </div>
      </div>
    );
  }
}

export default StatsCard;
